import { Box } from '@mui/material';

import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';

import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';

export const StatsSection = (props: { activeCompetition: CompetitionWithConfig | undefined }) => {
  return (
    <Section
      sx={{
        gap: { xs: '60px', lg: '120px' },
        flexDirection: { md: 'row' },
        alignItems: { md: 'center' },
        maxWidth: '1280px',
        position: 'relative',
        isolation: 'isolate',
      }}
    >
      <Box sx={{ order: { md: 1 }, flex: 5, textAlign: 'center' }}>
        <div className="mb-8 text-center typography-v1-h2">
          Vi ønsker at enda flere skal få lavere rente på sin forbruks- og kredittkortgjeld
        </div>
        <CTA
          activeCompetition={props.activeCompetition}
          onClick={() => {
            sendUserPortalEvent('jano25_competition_cta_stats_clicked');
          }}
        />
      </Box>
    </Section>
  );
};
